import { countChildren, dividerWidth } from "./utils";

export default (props, splitIndex, paneRects, delta) => {
  const constraintsArr = props.constraints.toArray();
  const childCount = countChildren(props.children);
  const dimensionKey = props.vertical ? "width" : "height";
  const nextIndex = splitIndex + 1;
  let newSizes = paneRects.map(s => {
    return { width: s.width, height: s.height };
  });

  const thisConstraint = constraintsArr[splitIndex];
  const nextConstraint = constraintsArr[nextIndex];

  // Calculate the current size occupied by the two views.
  const groupTotal = paneRects[splitIndex][dimensionKey] + paneRects[nextIndex][dimensionKey];

  // First calculate the size of the dragged item
  const thisTargetSize = paneRects[splitIndex][dimensionKey] + delta;

  // Test to see if we are collapsing
  if (thisConstraint.canCollapse && thisTargetSize < thisConstraint.minSize / 3) {
    // We are collapsing, drop back to the collapse size.
    newSizes[splitIndex][dimensionKey] = thisConstraint.collapseSize;
  } else {
    // We are not collapsing, so respect min and max values
    newSizes[splitIndex][dimensionKey] = Math.min(
      thisConstraint.maxSize,
      Math.max(thisConstraint.minSize, thisTargetSize)
    );
  }

  // Now adjust the second view based on previous group size and its neighbours new size
  newSizes[nextIndex][dimensionKey] = groupTotal - newSizes[splitIndex][dimensionKey];

  // Are we collapsing the next view?
  if (nextConstraint.canCollapse && newSizes[nextIndex][dimensionKey] < nextConstraint.minSize / 3) {
    // Collapsing, set it to the collapse size.
    newSizes[nextIndex][dimensionKey] = nextConstraint.collapseSize;
    // And now adjust the dragged item back based on group size and neightbour size
    newSizes[splitIndex][dimensionKey] = groupTotal - newSizes[nextIndex][dimensionKey];
  } else if (
    newSizes[nextIndex][dimensionKey] < nextConstraint.minSize ||
    newSizes[nextIndex][dimensionKey] > nextConstraint.maxSize
  ) {
    // Otherwise, not collapsing, so make sure that this next neighbour is still within its bounds also
    newSizes[nextIndex][dimensionKey] = Math.min(
      nextConstraint.maxSize,
      Math.max(nextConstraint.minSize, newSizes[nextIndex][dimensionKey])
    );
    // And now adjust the dragged item back based on group size and neightbour size
    newSizes[splitIndex][dimensionKey] = groupTotal - newSizes[nextIndex][dimensionKey];
  }

  // Now let it all hang out again...
  if (props.vertical) {
    let x = 0;
    for (let i = 0; i < childCount; i++) {
      newSizes[i].y = 0;
      newSizes[i].x = x;
      x += newSizes[i].width + dividerWidth(constraintsArr[i].hasDivider);
    }
  } else {
    let y = 0;
    for (let i = 0; i < childCount; i++) {
      newSizes[i].y = y;
      newSizes[i].x = 0;
      y += newSizes[i].height + dividerWidth(constraintsArr[i].hasDivider);
    }
  }

  return newSizes;
};
